<link rel="stylesheet" type="text/css" [href]="overrideCssUrl | safeUrl">
<ng-template #template>
  <router-outlet></router-outlet>
  <!-- <ngx-spinner bdColor="rgba(51,51,51,0.3)" type="ball-scale-multiple"></ngx-spinner> -->
  <favicon-loader [companyGuid]="companyGuid" [faviconUrl]="faviconUrl"></favicon-loader>
</ng-template>
<ngx-spinner bdColor="rgba(51,51,51,0.3)" size="large" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
  <p style="font-size: 20px; color: white">{{ 'common.pleaseWait' | transloco }}</p>
</ngx-spinner>
